import React from 'react';

const ExportCSVButton = ({exportCSVText, component, className}) => (
    
    <span className={className} title={exportCSVText}>
        {component}
    </span>
);

const UsersTotalCount = ({allUsersText, className}) => (
    
    <div className={className}>
        {allUsersText}
    </div>
);

export { ExportCSVButton, UsersTotalCount };


// WEBPACK FOOTER //
// ./src/components/users/toolBarButtons/index.jsx